export default function parseMessageInput(html: string) {
  const fragment = document.createElement('div');
  fragment.innerHTML = html;
  const text = fragment.innerText.trim().replace(/\u200b+/g, '');

  return text;
}
